export default {
    BEFORE: 'before',
    AFTER: 'after',
    UP: 'up',
    DOWN: 'down'
};   